module.exports = __webpack_public_path__ + "static/img/phone.c12c8e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/phone.png
// module id = fbCD
// module chunks = 1